module.exports = __webpack_public_path__ + "static/img/m-park4.c75ca2d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/m-park4.jpg
// module id = YKwt
// module chunks = 1